import { render, staticRenderFns } from "./PostAudit.vue?vue&type=template&id=213bc8cd&scoped=true"
import script from "./PostAudit.vue?vue&type=script&lang=js"
export * from "./PostAudit.vue?vue&type=script&lang=js"
import style0 from "./PostAudit.vue?vue&type=style&index=0&id=213bc8cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213bc8cd",
  null
  
)

export default component.exports